"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _gsap = require("gsap");

var errors = _interopRequireWildcard(require("./errors-const"));

var _utils = require("../utils");

var _promoVideo = _interopRequireDefault(require("../components/promo-video"));

var _promoPhoto = _interopRequireDefault(require("../components/promo-photo"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

// import { createAnimation } from 'promo-animation/dist/animations';
let cdn;
let map;
let container;
let container2;
let context;
let context2; // tween max timeline

let timeline;
let videoScale = 1;
const viewConfig = {
  width: 1280,
  height: 720
};

function onScaleChange(scale) {
  _gsap.TweenMax.set([container, container2], {
    width: viewConfig.width * scale,
    height: viewConfig.height * scale
  });
}

function clearContext(_context) {
  _context.clearRect(0, 0, viewConfig.width, viewConfig.height);
}

function draw(obj, _context) {
  const {
    el,
    x,
    y,
    w,
    h
  } = obj;
  const {
    width,
    height
  } = viewConfig;

  _context.drawImage(el, x, y, w, h, 0, 0, width, height);
}

function drawFilter(filter, _context) {
  const {
    width,
    height
  } = viewConfig;
  _context.fillStyle = (0, _utils.rgbaToString)(filter);

  _context.fillRect(0, 0, width, height);
}

function pauseAllClips() {
  map.forEach(value => {
    const {
      promoClip
    } = value;

    if (promoClip && promoClip.pause) {
      promoClip.pause();
    }
  });
}

class ClipsViewService {
  constructor(config) {
    if (config) {
      this.logger = config.logger || function () {};

      if (config.cdn) {
        cdn = config.cdn;
      }
    } // set ref to container dom element


    const {
      wrapper
    } = config; // create a div in the wrapper

    container = document.createElement('canvas');
    container.id = 'clips-view';
    wrapper.appendChild(container);
    context = container.getContext('2d');
    container2 = document.createElement('canvas');
    container2.id = 'clips-view-2';
    wrapper.appendChild(container2);
    context2 = container2.getContext('2d'); // set new map

    map = config.map; // set time line

    timeline = config.timeline; // set actions

    const {
      play,
      pause,
      time
    } = config;
    this.play = play;
    this.pause = pause;
    this.time = time;

    _gsap.TweenMax.set([container, container2], {
      position: 'absolute'
    });
  }

  set scale(scale) {
    onScaleChange(scale);
    videoScale = scale;
  }

  get scale() {
    return videoScale;
  }

  onPaused() {
    pauseAllClips();
  }

  clear() {
    map.forEach((value, key) => {
      if (value && value.promoClip) {
        this.destroy(key);
      }
    });
    clearContext(context);
    clearContext(context2);
  }

  onSeekEventClipView(eventName, guid, time) {
    if (_.isFunction(this.onSeekEvent)) {
      this.onSeekEvent(eventName, guid, time);
    }
  }

  async create(data, ratio, imageQuality) {
    if (!_.isString(ratio)) {
      throw errors.INVALID_PARMS;
    }

    if (!data) {
      throw errors.DECORATION_DATA_MISSING;
    }

    const {
      clips
    } = data;

    if (!clips) {
      throw errors.CLIPS_DATA_MISSING;
    }

    const {
      width,
      height
    } = (0, _utils.getRatioObjectBy)('ratio', ratio);
    viewConfig.width = width;
    viewConfig.height = height; // set canvas size origin video size

    container.width = width;
    container.height = height;
    container2.width = width;
    container2.height = height; // applay style with scale

    _gsap.TweenMax.set([container, container2], {
      position: 'absolute',
      width: width * videoScale,
      height: height * videoScale
    }); // clear canvas


    this.clear();
    await Promise.all(clips.map(async clip => {
      await this.render(clip.guid, clips, imageQuality);
    }));
  }

  async render(guid, data, imageQuality) {
    if (!_.isString(guid)) {
      throw errors.INVALID_PARMS;
    }

    if (!data) {
      throw errors.CLIPS_DATA_MISSING;
    }

    if (map.has(guid)) {
      this.destroy(guid);
    }

    const clip = (0, _utils.getClipByGuid)(data, guid);

    if (!clip) {
      throw errors.CLIP_NOT_FOUND;
    }

    const normalizeClip = (0, _utils.normalizeClipObject)(clip);
    const {
      type
    } = normalizeClip;
    this.logger.log(type);
    await new Promise((resolve
    /* , reject */
    ) => {
      if (type === _utils.CLIP_TYPE.VIDEO) {
        const promoVideo = new _promoVideo.default(normalizeClip);
        (0, _utils.addVideoClipTweens)(promoVideo, timeline, draw, drawFilter, clearContext, context, context2, _gsap.TweenMax, _gsap.Linear.easeNone, this.onSeekEventClipView.bind(this));
        map.set(guid, {
          promoClip: promoVideo,
          destroyFunc: promoVideo.destroy()
        });
        promoVideo.isReady.then(() => {
          this.logger.log('oncanplaythrough', guid);
          resolve(promoVideo);
        });
      }

      if (type === _utils.CLIP_TYPE.PHOTO) {
        const promoPhoto = new _promoPhoto.default(normalizeClip, cdn, imageQuality);
        map.set(guid, {
          promoClip: promoPhoto,
          destroyFunc: promoPhoto.destroy()
        });
        promoPhoto.isReady.then(() => {
          (0, _utils.addPhotoClipTweens)(promoPhoto, timeline, draw, drawFilter, clearContext, context, context2, _gsap.TweenMax, _gsap.Linear.easeNone);
          this.logger.log('photo is ready', guid);
          resolve(promoPhoto);
        });
      }
    });
  }

  destroy(guid) {
    if (!_.isString(guid)) {
      throw errors.INVALID_PARMS;
    }

    if (!map.has(guid)) {
      throw errors.CLIP_NOT_RENDERED;
    }

    if (map.has(guid)) {
      const {
        destroyFunc
      } = map.get(guid);
      destroyFunc.call();
      map.delete(guid);
    }
  }

}

exports.default = ClipsViewService;